module.exports = __webpack_public_path__ + "static/media/info.cf4c8310.svg";